import type { ComponentType } from "react";
import { Globe, LayoutGrid } from "lucide-react";

import { PICKER_STEP, PUBLIC_PROFILE_STEP, type Step } from "../domain/steps";

export type StepIcon = ComponentType<{ className?: string }>;

/** The icon each onboarding step shows above its title. */
const STEP_ICONS: Record<string, StepIcon> = {
    [PICKER_STEP.key]: LayoutGrid,
    [PUBLIC_PROFILE_STEP.key]: Globe,
};

export const iconForStep = (step: Step | null | undefined): StepIcon | undefined =>
    step ? STEP_ICONS[step.key] : undefined;
